/**
 * Whether a listing is vacant land, from whatever the payload carries: the
 * server's paperwork category, the promoted property type, or the MLS
 * profile's property type. Land has no bedrooms, baths or living area, so
 * cards show a "Vacant land" label instead of "N/A Beds · 0 Baths".
 *
 * @param {Object|null|undefined} house
 * @returns {boolean}
 */
export function isVacantLand(house) {
  if (!house) return false;
  if (house.paperwork_category === 'vacant_land') return true;
  const type = String(house.property_type || house.mls_profile?.property_type || '').trim().toLowerCase();
  return type === 'land';
}

/** The label cards show in place of the beds/baths/sqft facts for land. */
export const VACANT_LAND_LABEL = 'Vacant land';

/**
 * Property types a buyer can search by: the values stored on listings
 * (`houses.property_type`) and the backend's search filter accepts.
 */
export const PROPERTY_TYPE_OPTIONS = [
  { value: 'single_family', label: 'Single family' },
  { value: 'condo', label: 'Condo' },
  { value: 'townhouse', label: 'Townhouse' },
  { value: 'multi_family', label: 'Multi-family' },
  { value: 'mobile_home', label: 'Mobile home' },
  { value: 'land', label: 'Land' },
];

/** The label for a stored property type value, or the value itself. */
export const propertyTypeLabel = (value) => (
  PROPERTY_TYPE_OPTIONS.find((o) => o.value === value)?.label || value
);
